var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "text-2xl text-default-400 pointer-events-none",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.271 9.1783c-0.29-0.46-0.6-0.89-0.92-1.29-0.37-0.47-1.07-0.51-1.49-0.09l-3 3c0.22 0.66 0.26 1.42 0.06 2.21-0.35 1.41-1.49 2.55-2.9 2.9-0.79 0.2-1.55 0.16-2.21-0.06 0 0-1.43 1.43-2.46 2.46-0.5 0.5-0.34 1.38 0.33 1.64 1.07 0.41 2.18 0.62 3.32 0.62 1.78 0 3.51-0.52 5.09-1.49 1.61-1 3.06-2.47 4.23-4.34 0.95-1.51 0.9-4.05-0.05-5.56z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.021 9.9806-4.04 4.04c-0.51-0.52-0.84-1.24-0.84-2.02 0-1.57 1.28-2.86 2.86-2.86 0.78 0 1.5 0.33 2.02 0.84z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.25 5.7497-3.39 3.39c-0.73-0.74-1.74-1.18-2.86-1.18-2.24 0-4.04 1.81-4.04 4.04 0 1.12 0.45 2.13 1.18 2.86l-3.38 3.39h-0.01c-1.11-0.9-2.13-2.05-3-3.41-1-1.57-1-4.12 0-5.69 1.16-1.82 2.58-3.25 4.16-4.23 1.58-0.96 3.31-1.49 5.09-1.49 2.23 0 4.39 0.82 6.25 2.32z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.858 11.998c0 1.57-1.28 2.86-2.86 2.86-0.06 0-0.11 0-0.17-0.02l3.01-3.01c0.02 0.06 0.02 0.11 0.02 0.17z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.769 2.2289c-0.3-0.3-0.79-0.3-1.09 0l-18.45 18.46c-0.3 0.3-0.3 0.79 0 1.09 0.15 0.14 0.34 0.22 0.54 0.22s0.39-0.08 0.54-0.23l18.46-18.46c0.31-0.3 0.31-0.78 0-1.08z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHidden);
export default __webpack_public_path__ + "static/media/eye_hidden.b61a6fd912e22007da158875bed9739f.svg";
export { ForwardRef as ReactComponent };